import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import { cloudinary_url, video_cloudinary_url } from "../utils/url";
import UserContext from "../UserContext";
import { fileExtension } from "../utils/fileExtension";

const DiscoverToPosts = () => {
  const { user, mode: darkMode, topposts: posts } = React.useContext(
    UserContext
  );

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 3,
    },
  };

  React.useEffect(() => {}, [user]);
  return (
    <div className={`dicover-container ${darkMode ? "dark" : ""}`}>
      <Carousel
        className=""
        responsive={responsive}
        keyBoardControl={true}
        draggable={true}
        swipeable={true}
      >
        {posts.map((post) => {
          // check the video or image data coming
          let dataFile;
          let filename;
          let fileExt;
          // check data.image ext. type
          if (post.image) {
            filename = post?.image;
            fileExt = fileExtension(filename).slice(1);
            if (
              fileExt === "mp4" ||
              fileExt === "mpg" ||
              fileExt === "mpeg" ||
              fileExt === "vob" ||
              fileExt === "avi" ||
              fileExt === "webm"
            ) {
              dataFile = "video";
            } else dataFile = "picture";
          }

          const image_file = post?.image?.startsWith("http")
            ? post?.image
            : cloudinary_url + post.image;
          const video_file = post?.image?.startsWith("http")
            ? post?.image
            : video_cloudinary_url + post.image;

          if (!post.image || dataFile === "video") return null;

          return (
            <div
              className=" cursor-pointer text-center pb-2 rounded"
              key={post._id}
            >
             
              <Link className="" to={`/p/${post._id}`}>
              <div className="bg-gray-100 w-28">
                {dataFile === "picture" ? (
                  <img
                    src={image_file}
                    alt=""
                    className="rounded w-100 h-full object-cover"
                  />
                ) : (
                  <video
                    src={video_file}
                    alt=""
                    className="rounded w-100 h-full object-cover"
                  />
                )}
                </div>
                <div className="w-24 flex justify-center">
                <small className="block mt-2 text-xs font-bold px-1 text-fire">
                  @{post?.author?.username || "Twik"}
                </small>
                </div>
              </Link>
            </div>
          );
        })}
      </Carousel>
    </div>
  );
};

export default DiscoverToPosts;